(function () {
	const productSlider = () => {
		document.querySelectorAll(".js-get-section").forEach(function (parent) {
			if (parent.dataset.carouselInit) return;

			let carousel = parent.querySelector(`.js-swiper-product-carousel`);
			if (!carousel || typeof Swiper !== "function") return;
			parent.dataset.carouselInit = "1";

			let scrollBar = parent.querySelector(
				`.js-product-carousel-swiper-scrollbar`
			);

			let prev = parent.querySelector(`.js-product-carousel-arrow-prev`);

			let next = parent.querySelector(`.js-product-carousel-arrow-next`);

			let swiperCarousel = new Swiper(carousel, {
				slidesPerView: 1.2,
				spaceBetween: 20,
				slidesOffsetAfter: 20,
				autoplay: {
					delay: 3500,
					disableOnInteraction: true,
					pauseOnMouseEnter: true,
				},
				speed: 800,
				scrollbar: {
					el: scrollBar,
					draggable: true,
				},
				navigation: {
					prevEl: prev,
					nextEl: next,
				},
				breakpoints: {
					750: { slidesPerView: 1.2, spaceBetween: 20, slidesOffsetAfter: 0 },
					990: { slidesPerView: 2, spaceBetween: 24, slidesOffsetAfter: 0 },
					1100: { slidesPerView: 3, spaceBetween: 24, slidesOffsetAfter: 0 },
				},
			});

			swiperCarousel.autoplay.stop();

			if ("IntersectionObserver" in window) {
				var observer = new IntersectionObserver(
					function (entries) {
						entries.forEach(function (entry) {
							if (entry.isIntersecting) {
								swiperCarousel.autoplay.start();
							} else {
								swiperCarousel.autoplay.stop();
							}
						});
					},
					{ threshold: 0.3 }
				);
				observer.observe(carousel);
			}

			if (
				(prev && prev.classList.contains("swiper-button-lock")) ||
				(next && next.classList.contains("swiper-button-lock"))
			) {
				const navTools = parent.querySelector(".product-carousel_nav-tools");
				if (navTools) navTools.style.display = "none";
			}
		});
	};

	const init = () => {
		productSlider();
		document.addEventListener("shopify:section:load", productSlider);
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
